import type { ReactElement } from 'react';
import { socialSignInUrl } from '@/shared/api';
import { Button } from '@/shared/ui';
import { GoogleIcon } from './google-icon';
import { KakaoIcon } from './kakao-icon';
import { NaverIcon } from './naver-icon';

/** 원형 로고 버튼 — 각 서비스 색 바탕에 심볼만 싣는다. 이름은 aria-label 이 준다. */
const CIRCLE_CLASS = 'size-12 rounded-full p-0 transition-transform hover:-translate-y-0.5';
const NAVER_CLASS = 'bg-[#03C75A] text-white hover:bg-[#03C75A] [&_svg]:size-4';
const KAKAO_CLASS = 'bg-[#FEE500] text-black/85 hover:bg-[#FEE500] [&_svg]:size-6';
// 구글은 흰 바탕에 테두리(브랜드 지침의 밝은 버튼) — 호버에도 바탕을 유지한다.
const GOOGLE_CLASS = 'border border-foreground/15 bg-white hover:bg-white [&_svg]:size-5';

/**
 * 소셜 로그인 진입 버튼 — "간편 로그인" 아래 원형 로고 세 개(네이버·카카오·구글)를 나란히 둔다.
 * OAuth 는 리다이렉트 플로우라 최상위 내비게이션으로 이동한다.
 * 미구성 프로바이더는 서버가 503 페이지로 알려준다. (로컬에서 앱 등록 전일 수 있다)
 */
export const SocialSignInButtons = (): ReactElement => (
  <div className="flex flex-col items-center gap-4">
    <p className="text-xs text-muted-foreground">간편 로그인</p>
    <div className="flex items-center gap-4">
      <Button
        type="button"
        aria-label="네이버로 계속하기"
        className={`${CIRCLE_CLASS} ${NAVER_CLASS}`}
        onClick={() => {
          window.location.href = socialSignInUrl('naver');
        }}
      >
        <NaverIcon />
      </Button>
      <Button
        type="button"
        aria-label="카카오로 계속하기"
        className={`${CIRCLE_CLASS} ${KAKAO_CLASS}`}
        onClick={() => {
          window.location.href = socialSignInUrl('kakao');
        }}
      >
        <KakaoIcon />
      </Button>
      <Button
        type="button"
        aria-label="구글로 계속하기"
        className={`${CIRCLE_CLASS} ${GOOGLE_CLASS}`}
        onClick={() => {
          window.location.href = socialSignInUrl('google');
        }}
      >
        <GoogleIcon />
      </Button>
    </div>
  </div>
);
